// extracted by mini-css-extract-plugin
module.exports = {"filled":"styles_filled__2bLVh","error":"styles_error__2swsm","dish-note":"styles_dish-note__2S555"};